// extracted by mini-css-extract-plugin
export default {"loading":"Toast_loading__MYbTB","rotation":"Toast_rotation__EoyQA"};